module.exports = __webpack_public_path__ + "static/media/Panorama-St-Peter-Basilica.c6d46f89.jpg";